import { Component, OnInit } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
// import am4themes_dataviz from "@amcharts/amcharts4/themes/dataviz";
import { CstemapiService } from '../cstemapi.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { reduce } from 'rxjs/operators';
import * as $ from 'jquery';
// import { Chart } from 'angular-highcharts';
// import * as Highcharts from 'highcharts';

declare var Highcharts: any;
declare var zingchart: any;

@Component({
  selector: 'app-outputtechnical',
  templateUrl: './outputtechnical.component.html',
  styleUrls: ['./outputtechnical.component.scss']
})
export class OutputtechnicalComponent implements OnInit {
  chart1: any; chart2: any; chart3: any; chart4: any; chart5: any;
  histogram = '1';
  energyFlow;
  degradationPlant = 'pvModuleRating';
  dailychart1: any;
  chooseoptions: any;
  caseDetails: any;
  mgen: any = '1';
  dgen: any = '1';
  monthList = []; monthId = 1;

  constructor(private cstemapi: CstemapiService, private myRoute: Router, private auth: AuthService) {
    this.chooseoptions = this.auth.getAppCode();
    this.caseDetails = this.auth.getCaseDetails();
    this.monthList = [
      { id: 1, month: 'Jan' },
      { id: 2, month: 'Feb' },
      { id: 3, month: 'Mar' },
      { id: 4, month: 'Apr' },
      { id: 5, month: 'May' },
      { id: 6, month: 'Jun' },
      { id: 7, month: 'Jul' },
      { id: 8, month: 'Aug' },
      { id: 9, month: 'Sep' },
      { id: 10, month: 'Oct' },
      { id: 11, month: 'Nov' },
      { id: 12, month: 'Dec' }
    ]
  }

  ngOnInit() {
    this.getEnergyFlow();
    window.scroll(0, 0);
    let top = document.getElementById('energy');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }

    $(document).ready(function () {
      $('.sidelinks-sm').click(function () {
        $('.sidelinks').toggle();
      })
    })
  }

  ngAfterViewInit() {
    am4core.useTheme(am4themes_animated);

    this.getMonthlyData();
    this.getDailyData();
    this.getHourlyData();
    this.histogramChange();

    this.degradationCaseChange();

    if (this.caseDetails.applicationTypeCode != 'util') {
      this.getBatteryReport('batteryLoad');
      this.getBatteryReport('powerToOrFromBattery');
      this.getBatteryReport('excessSupply');
      this.getBatteryReport('unmetLoad');
      this.getBatteryReport('batterySOCProfile');

      this.getBatteryWeekReport(1);
    }

  }

  getEnergyFlow() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId()
    };
    var api = 'reports/getEnergyFlowDetails'
    this.cstemapi.cstemAPI(dObj).GetEnergyFlowDetails.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.energyFlow = resData;

        var eedata = [["Annual Agg. Solar Energy", "Annual Raw DC Generation", resData.anPplantDC],
        ["Annual Agg. Solar Energy", "Loss Due to Conversion Efficiency", resData.aggGtallmodulesTW - resData.anPplantDC],
        ["Annual Raw DC Generation", "Soiling Loss", resData.soilingLoss],
        ["Annual Raw DC Generation", "Annual DC Generation", resData.anPplantDCincSL],
        ["Annual DC Generation", "Electrical Loss", resData.electricalLoss],

          // ["Annual DC Generation", "Annual AC Generation", resData.anPplantAC]
        ]

        if (this.caseDetails.applicationTypeCode == 'util') {
          eedata.push(
            ["Annual DC Generation", "Annual AC Generation", resData.anPplantAC])
        }

        if (this.caseDetails.applicationTypeCode == 'gcmg') {
          eedata.push(
            ["Annual DC Generation", "AC Energy Available", resData.anPplantAC],
            ["From Grid", "AC Energy Available", resData.fromGrid],
            ["AC Energy Available", "Battery System Loss", resData.anPplantAC + resData.fromGrid - (this.auth.getDailyLoad() * 0.365) - resData.toGrid],
            ["AC Energy Available", "Load", this.auth.getDailyLoad() * 0.365],
            ["AC Energy Available", "PV To Grid", resData.toGrid])

          // ["Annual AC Generation", "Load", resData.anPplantAC - resData.toGrid],
          // ["Annual AC Generation", "To grid", resData.toGrid],
          // ["Annual AC Generation", "Battery Loss", resData.anPplantAC - (resData.anPplantAC - resData.toGrid + resData.fromGrid)],
          // ["From Grid", "Load", resData.fromGrid])
        }
        // console.log(this.auth.getDailyLoad() * 0.365)
        if (this.caseDetails.applicationTypeCode == 'ogmg') {
          /* load not met -  resData.fromGrid 
          load met - (this.auth.getDailyLoad() * 0.365) - resData.fromGrid */
          eedata.push(
            ["Annual DC Generation", "Annual AC Generation", resData.anPplantAC],
            ["Annual AC Generation", "Generation Not Used", resData.toGrid],
            ["Annual AC Generation", "Load", resData.anPplantAC - resData.toGrid],
            ["Load", "Load not Met", resData.fromGrid],
            ["Load", "Battery Sys. Loss", resData.anPplantAC - resData.toGrid - ((this.auth.getDailyLoad() * 0.365) - resData.fromGrid)],
            ["Load", "Load Met", (this.auth.getDailyLoad() * 0.365) - resData.fromGrid],

            // ["Annual DC Generation", "Annual AC Generation", resData.anPplantAC],
            // ["Annual AC Generation", "Load", resData.anPplantAC - resData.toGrid],
            // ["Annual AC Generation", "Generation Not Used", resData.toGrid],
            // // ["From Grid", "Load not Met", resData.fromGrid],
            // ["Annual AC Generation", "Battery Loss", resData.anPplantAC - (resData.anPplantAC - resData.toGrid + resData.fromGrid)],
            // ["Load", "Load not Met", resData.fromGrid]
          )
        }

        this.energyFlowChart(eedata);
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting energy flow details', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  monthlyDailyChange(id, type) {
    if (id == 1) {
      if (type == 'monthly') {
        this.getMonthlyData();
      } else {
        this.getDailyData();
      }
    } else {
      var dObj = {
        userId: this.auth.getUserId(),
        plantId: this.auth.getPlantId(),
        type: type
      };
      var api = 'reports/getBatteryAggregateReport';
      this.cstemapi.cstemAPI(dObj).GetBatteryAggregateReport.subscribe(data => {
        this.cstemapi.printReqRes(dObj, data, api);
        let resData: any = data;

        if (resData.statusCode == 'S001') {
          if (type == 'monthly') {
            var mdata = [];
            for (var i = 0; i < resData.values.length; i++) {
              mdata.push({
                month: this.cstemapi.monthName[i],
                mvalue: resData.values[i]
              });
              if (mdata.length == 12) {
                // this.monthChart(mdata);
                this.monthChart(resData.values, 'kWh');
              }
            }
          } else {
            var dates = [];
            var d, dailydata = [];
            for (var i = 1; i <= 12; i++) {
              d = this.daysInMonth(i, 2019);
              for (var j = 1; j <= d; j++) {
                if (i == 2 && j == 29) {
                  // console.log('leap year')
                } else {
                  dates.push(2019 + '-' + i + '-' + j)
                }
              }
            }

            if (dates.length == 365) {
              for (var i = 0; i < dates.length; i++) {
                dailydata.push([dates[i], resData.values[i]]);
              }
            }

            if (dailydata.length == resData.values.length) {
              // console.log(dailydata)
              this.dailyGen(dailydata);
              zingchart.render({
                id: 'container',
                data: this.dailychart1,
                height: '100%',
                width: '100%'
              });
            }
          }

        }

        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire('Error!', 'Error while getting battery aggregate generation', 'error');
        }

      }, (error) => {
        this.cstemapi.Swal.fire('Oops...', error, 'error');
      });
    }
  }

  getMonthlyData() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: 'monthly'
    };
    var api = 'reports/getAggregatePvGeneration'
    this.cstemapi.cstemAPI(dObj).GetMonthlyAggregatePVGeneration.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        var mdata = [];
        for (var i = 0; i < resData.generationValue.length; i++) {
          mdata.push({
            month: this.cstemapi.monthName[i],
            mvalue: parseFloat(resData.generationValue[i].toFixed(2))
          });

          if (mdata.length == 12) {
            if (this.caseDetails.applicationTypeCode != 'util') {
              this.monthChart(resData.generationValue, 'kWh');
            } else {
              this.monthChart(resData.generationValue, 'MWh');
            }
          }
        }
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting monthly aggregate PV generation', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  getDailyData() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: 'daily'
    };
    var api = 'reports/getAggregatePvGeneration'
    this.cstemapi.cstemAPI(dObj).GetDailyAggregatePVGeneration.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {

        var dates = [];
        var d, dailydata = [];
        for (var i = 1; i <= 12; i++) {
          d = this.daysInMonth(i, 2019);
          for (var j = 1; j <= d; j++) {
            if (i == 2 && j == 29) {
              // console.log('leap year')
            } else {
              dates.push(2019 + '-' + i + '-' + j)
            }
          }
        }

        if (dates.length == 365) {
          for (var i = 0; i < dates.length; i++) {
            dailydata.push([dates[i], resData.generationValue[i].toFixed(2)]);
          }
        }

        if (dailydata.length == resData.generationValue.length) {
          // console.log(dailydata)
          this.dailyGen(dailydata);
          zingchart.render({
            id: 'container',
            data: this.dailychart1,
            height: '100%',
            width: '100%'
          });
        }
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting daily aggregate PV generation', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  dailyGen(ddata) {
    var unit;
    if (this.caseDetails.applicationTypeCode != 'util') {
      unit = 'kWh';
    } else {
      unit = 'MWh';
    }

    if (this.auth.getGuestUserId() == '' && this.auth.getIsGuest() == 'true') {
      this.dailychart1 = {
        gui: {
          contextMenu: {
            button: {
              visible: true,
            }
          }
        },
        type: 'calendar',
        title: {
          text: '',
          fontSize: 17,
        },
        options: {
          year: {
            text: '2019',
            visible: false
          },
          rows: 2,
          palette: ['none', '#3F51B5'],
          scale: {
            x: '75%',
            y: '15%',
            height: 10,
            width: '30%'
          },
          month: {
            item: {
              fontColor: 'black',
              fontSize: 14
            },
            outline: {
              borderColor: '#BDBDBD',
              active: {
                borderColor: '#BDBDBD'
              }
            }
          },
          weekday: {
            values: ['', '', '', '', '', '', ''],
            item: {
              fontColor: 'gray',
              fontSize: 9
            }
          },
          day: {
            inactive: {
              backgroundColor: '#F5F5F5'
            }
          },
          values: ddata
        },
        plot: {
          valueBox: { // Use this object to configure the value boxes.
            fontColor: 'white',
            // fontFamily: 'Courier New',
            fontSize: 12,
            fontWeight: 'normal'
          },
          tooltip: {
            text: '%v ' + unit,
            alpha: 0.8,
            backgroundColor: '#212121',
            borderColor: '#212121',
            borderRadius: 3,
            fontColor: 'white',
            fontSize: 20,
            offsetY: -10,
            textAlign: 'center',
            textAlpha: 1
          }
        },
        plotarea: {
          marginTop: '25%',
          marginBottom: '10%'
        }
      };
    } else {
      this.dailychart1 = {
        type: 'calendar',
        title: {
          text: '',
          fontSize: 17,
        },
        options: {
          year: {
            text: '2019',
            visible: false
          },
          rows: 2,
          palette: ['none', '#3F51B5'],
          scale: {
            x: '75%',
            y: '15%',
            height: 10,
            width: '30%'
          },
          month: {
            item: {
              fontColor: 'black',
              fontSize: 14
            },
            outline: {
              borderColor: '#BDBDBD',
              active: {
                borderColor: '#BDBDBD'
              }
            }
          },
          weekday: {
            values: ['', '', '', '', '', '', ''],
            item: {
              fontColor: 'gray',
              fontSize: 9
            }
          },
          day: {
            inactive: {
              backgroundColor: '#F5F5F5'
            }
          },
          values: ddata
        },
        plot: {
          valueBox: { // Use this object to configure the value boxes.
            fontColor: 'white',
            // fontFamily: 'Courier New',
            fontSize: 12,
            fontWeight: 'normal'
          },
          tooltip: {
            text: '%v ' + unit,
            alpha: 0.8,
            backgroundColor: '#212121',
            borderColor: '#212121',
            borderRadius: 3,
            fontColor: 'white',
            fontSize: 20,
            offsetY: -10,
            textAlign: 'center',
            textAlpha: 1
          }
        },
        plotarea: {
          marginTop: '25%',
          marginBottom: '10%'
        }
      };
    }
  }

  getHourlyData() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: 'hourly'
    };
    var api = 'reports/getAggregatePvGeneration'

    this.cstemapi.cstemAPI(dObj).GetHourlyAggregatePVGeneration.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);

      let resData: any = data;
      if (resData.statusCode == 'S001') {

        if (this.caseDetails.applicationTypeCode != 'util') {
          this.hourleyChart1(resData.generationValue, 'kW')
        } else {
          this.hourleyChart1(resData.generationValue, 'MW')
        }
       
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting hourly aggregate PV generation', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  energyFlowChart(data) {
    // console.log(data)
    Highcharts.chart('energyChart', {
      title: {
        text: ''
      },
      tooltip: {
        valueDecimals: 2,
        valueSuffix: '  MWh',
        style: this.cstemapi.h_x_y_tooltip_format,
        pointFormatter: function () {
          // console.log(this)
          return this.from + ' - ' + this.to + ': ' + '<strong>' + this.weight.toFixed(2) + ' MWh' + '</strong>'
        },
        nodeFormatter: function () {
          // console.log(this)
          return this.name + ': <strong>' + this.sum.toFixed(2) + ' MWh </strong>'
        },
      },
      series: [{
        keys: ['from', 'to', 'weight'],
        data: data,
        type: 'sankey',
        name: 'System Energy Flow',
        sankey: {
          tooltip: {
            valueSuffix: ' ghgj',
          }
        }
      }]

    });
  }

  monthChart(mdata, unit) {
    Highcharts.chart('monthlyChart', {
      chart: {
        renderTo: 'monthlyChart',
        type: 'column'
      },
      title: {
        text: ''
      },
      tooltip: {
        shared: true,
        headerFormat: '<b>{point.key}</b><br/>',
        valueDecimals: 2,
        style: this.cstemapi.h_x_y_tooltip_format
      },
      xAxis: {
        categories: this.cstemapi.monthName,
        crosshair: true,
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: [{
        title: {
          text: unit,
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      }, {
        title: {
          text: 'Pareto',
          style: this.cstemapi.h_x_y_title_format
        },
        minPadding: 0,
        maxPadding: 0,
        max: 100,
        min: 0,
        opposite: true,
        labels: {
          format: "{value}%",
          style: this.cstemapi.h_x_y_format
        }
      }],
      plotOptions: {
        candlestick: {
          lineColor: '#2f7ed8'
        }
      },
      series: [{
        type: 'pareto',
        name: 'Pareto',
        yAxis: 1,
        zIndex: 10,
        baseSeries: 1,
        showInLegend: false,
        tooltip: {
          valueSuffix: ' %'
        },
        color: Highcharts.getOptions().colors[1],
      }, {
        name: 'Aggregate',
        type: 'column',
        zIndex: 2,
        data: mdata,
        showInLegend: false,
        tooltip: {
          valueSuffix: ' ' + unit
        },
        color: Highcharts.getOptions().colors[0],
      }]
    });

    // if (this.chart2 != undefined) {
    //   this.chart2.dispose();
    //   this.chart2 = null;
    // }
    // // console.log(mdata);
    // // Create chart instance
    // var chart = am4core.create("monthlyChart", am4charts.XYChart);
    // // chart.scrollbarX = new am4core.Scrollbar();

    // // Add data
    // chart.data = mdata;

    // prepareParetoData();

    // function prepareParetoData() {
    //   var total = 0;

    //   for (var i = 0; i < chart.data.length; i++) {
    //     var value = chart.data[i].mvalue;
    //     total += value;
    //   }

    //   var sum = 0;
    //   for (var i = 0; i < chart.data.length; i++) {
    //     var value = chart.data[i].mvalue;
    //     sum += value;
    //     chart.data[i].pareto = sum / total * 100;
    //   }
    // }

    // // Create axes
    // var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    // categoryAxis.dataFields.category = "month";
    // categoryAxis.renderer.grid.template.location = 0;
    // categoryAxis.renderer.minGridDistance = 60;
    // categoryAxis.tooltip.disabled = true;

    // var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // valueAxis.renderer.minWidth = 50;
    // valueAxis.min = 0;
    // valueAxis.cursorTooltipEnabled = false;
    // valueAxis.title.text = 'MWh';
    // valueAxis.title.fontWeight = 'bold';

    // // Create series
    // var series = chart.series.push(new am4charts.ColumnSeries());
    // series.sequencedInterpolation = true;
    // series.dataFields.valueY = "mvalue";
    // series.dataFields.categoryX = "month";
    // series.tooltipText = "[{categoryX}: bold]{valueY}[/] MWh";
    // series.columns.template.strokeWidth = 0;

    // series.tooltip.pointerOrientation = "vertical";

    // series.columns.template.column.cornerRadiusTopLeft = 10;
    // series.columns.template.column.cornerRadiusTopRight = 10;
    // series.columns.template.column.fillOpacity = 0.8;

    // // on hover, make corner radiuses bigger
    // var hoverState = series.columns.template.column.states.create("hover");
    // hoverState.properties.cornerRadiusTopLeft = 0;
    // hoverState.properties.cornerRadiusTopRight = 0;
    // hoverState.properties.fillOpacity = 1;

    // series.columns.template.adapter.add("fill", (fill, target) => {
    //   return chart.colors.getIndex(target.dataItem.index);
    // })


    // var paretoValueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // paretoValueAxis.renderer.opposite = true;
    // paretoValueAxis.min = 0;
    // paretoValueAxis.max = 100;
    // paretoValueAxis.strictMinMax = true;
    // paretoValueAxis.renderer.grid.template.disabled = true;
    // paretoValueAxis.numberFormatter = new am4core.NumberFormatter();
    // paretoValueAxis.numberFormatter.numberFormat = "#'%'"
    // paretoValueAxis.cursorTooltipEnabled = false;

    // var paretoSeries = chart.series.push(new am4charts.LineSeries())
    // paretoSeries.dataFields.valueY = "pareto";
    // paretoSeries.dataFields.categoryX = "month";
    // paretoSeries.yAxis = paretoValueAxis;
    // paretoSeries.tooltipText = "pareto: {valueY.formatNumber('#.0')}%[/]";
    // paretoSeries.bullets.push(new am4charts.CircleBullet());
    // paretoSeries.strokeWidth = 2;
    // paretoSeries.stroke = new am4core.InterfaceColorSet().getFor("alternativeBackground");
    // paretoSeries.strokeOpacity = 0.5;

    // // Cursor
    // chart.cursor = new am4charts.XYCursor();
    // chart.cursor.behavior = "panX";

    // this.chart2 = chart;
  }

  histogramChange() {
    if (this.histogram == '1') {
      var dObj = {
        userId: this.auth.getUserId(),
        plantId: this.auth.getPlantId()
      };
      var api = 'reports/hourlyDistributionOfPv'
      this.cstemapi.cstemAPI(dObj).GetHourlyDistributionOfPV.subscribe(data => {
        this.cstemapi.printReqRes(dObj, data, api);
        let resData: any = data;
        if (resData.statusCode == 'S001') {
          var h1data = [];
          var xlabel = ['1% to 10%', '10% to 20%', '20% to 30%', '30% to 40%', '40% to 50%', '50% to 60%', '60% to 70%', '70% to 80%', '80% to 90%', '90% to 100%', '> 100%'];
          for (var i = 0; i < resData.hourlyDistributionOfPv.length; i++) {
            h1data.push({
              xlab: xlabel[i],
              value: resData.hourlyDistributionOfPv[i]
            });
            if (h1data.length == resData.hourlyDistributionOfPv.length) {              // this.histogramChart1(h1data, 'Hours');
              this.histogramChart1(xlabel, resData.hourlyDistributionOfPv, 'Hours');
            }
          }
        }

        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire('Error!', '', 'error');
        }

      }, (error) => {
        this.cstemapi.Swal.fire('Oops...', error, 'error');
      });
    }

    if (this.histogram == '2') {
      var dObj = {
        userId: this.auth.getUserId(),
        plantId: this.auth.getPlantId()
      };
      var api = 'reports/hourWiseRangePvGeneration'
      this.cstemapi.cstemAPI(dObj).GetHourWiseRangeGenerationOfPV.subscribe(data => {
        this.cstemapi.printReqRes(dObj, data, api);

        let resData: any = data;
        if (resData.statusCode == 'S001') {
          var h2data = [], mean = [];
          for (var i = 0; i < resData.getHourWiseRangePvGeneration.max.length; i++) {
            h2data.push([i, resData.getHourWiseRangePvGeneration.min[i], resData.getHourWiseRangePvGeneration.max[i]]);
            mean.push(resData.getHourWiseRangePvGeneration.mean[i])
          }
          if (resData.getHourWiseRangePvGeneration.max.length == h2data.length) {
            if (this.caseDetails.applicationTypeCode != 'util') {
              this.histogramChart2(h2data, mean, 'kW');
            } else {
              this.histogramChart2(h2data, mean, 'MW');
            }
          }
        }

        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire('Error!', '', 'error');
        }

      }, (error) => {
        this.cstemapi.Swal.fire('Oops...', error, 'error');
      });
    }

    if (this.histogram == '3') {
      var dObj = {
        userId: this.auth.getUserId(),
        plantId: this.auth.getPlantId()
      };
      var api = 'reports/hourWiseDistributionAggGeneration'
      this.cstemapi.cstemAPI(dObj).GetHourwiseDistributionAggGeneration.subscribe(data => {
        this.cstemapi.printReqRes(dObj, data, api);
        let resData: any = data;
        if (resData.statusCode == 'S001') {
          this.histogramChart3(resData.hourWiseDistributionAggGeneration.sumGenPVACTW, resData.hourWiseDistributionAggGeneration.pcshareGenACTW);
        }

        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire('Error!', '', 'error');
        }

      }, (error) => {
        this.cstemapi.Swal.fire('Oops...', error, 'error');
      });
    }
  }

  degradationCaseChange() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: this.degradationPlant
    };
    var api = 'reports/getBatteryReport'
    if (this.degradationPlant == 'batteryBankReplacement') {

      this.cstemapi.cstemAPI(dObj).GetBatteryReport.subscribe(data => {
        this.cstemapi.printReqRes(dObj, data, api);
        let resData: any = data;
        if (resData.statusCode == 'S001') {
          var hdata = [];
          for (var i = 0; i < resData.values.length; i++) {
            hdata.push({
              x: i + 1,
              ay: resData.values[i],
              aValue: 5
            });
            if (hdata.length == resData.values.length) {
              this.degradtionChart_battery(resData.values);
            }
          }
        }

        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire('Error!', 'Error while getting bank replacement details', 'error');
        }

      }, (error) => {
        this.cstemapi.Swal.fire('Oops...', error, 'error');
      });
    } else {

      var api = 'reports/getBatteryWeekelyReports'
      this.cstemapi.cstemAPI(dObj).GetDegradtionReport.subscribe(data => {
        this.cstemapi.printReqRes(dObj, data, api);
        let resData: any = data;
        if (resData.statusCode == 'S001') {
          var hdata = [];
          for (var i = 0; i < resData.degradationDetails.length; i++) {
            hdata.push({
              date: i,
              value: resData.degradationDetails[i]
            });
            if (hdata.length == resData.degradationDetails.length) {
              if (this.degradationPlant == 'pvModuleRating') {
                this.degradtionChart(resData.degradationDetails, 'Wp');
              }
              if (this.degradationPlant == 'generation') {
                this.degradtionChart(resData.degradationDetails, 'MWh');
              }
              if (this.degradationPlant == 'CUF' || this.degradationPlant == 'SEE') {
                this.degradtionChart(resData.degradationDetails, '%');
              }
            }
          }
        }

        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire('Error!', 'Error while getting degradation details', 'error');
        }

      }, (error) => {
        this.cstemapi.Swal.fire('Oops...', error, 'error');
      });
    }

  }

  histogramChart1(xdata, ydata, yAxesName) {
    Highcharts.chart('histogramChart', {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: xdata,
        labels: {
          rotation: -45,
          style: this.cstemapi.h_x_y_format
        },
      },
      yAxis: {
        labels: {
          style: this.cstemapi.h_x_y_format
        },
        title: {
          text: yAxesName,
          style: this.cstemapi.h_x_y_title_format
        }
      },
      tooltip: {
        formatter: function () {
          return this.point.category + ': <b>' + this.point.y + ' ' + yAxesName + '</b>';
        },
        style: this.cstemapi.h_x_y_tooltip_format
      },
      series: [{
        name: yAxesName,
        data: ydata,
        showInLegend: false
      }]
    });
  }

  histogramChart2(hdata, avg, unit) {
    Highcharts.chart('histogramChart', {
      title: {
        text: ''
      },
      xAxis: {
        tickInterval: 1,
        title: {
          text: 'Hours',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          enabled: true,
          formatter: function () { return hdata[this.value][0]; },
          style: this.cstemapi.h_x_y_format
        }
      },

      yAxis: {
        title: {
          text: unit,
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        headerFormat: '<b>{point.key}</b><br/>',
        style: this.cstemapi.h_x_y_tooltip_format,
        valueSuffix: ' ' + unit
      },
      series: [{
        name: 'Mean',
        data: avg,
        zIndex: 1,
        marker: {
          fillColor: 'white',
          lineWidth: 2,
          lineColor: Highcharts.getOptions().colors[0]
        },
        showInLegend: false,
      }, {
        name: 'Min - Max',
        data: hdata,
        type: 'arearange',
        lineWidth: 0,
        linkedTo: ':previous',
        color: Highcharts.getOptions().colors[0],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false
        }
      }]
    });

  }

  histogramChart3(Sum, SumPC) {
    if (this.chart3 != undefined) {
      this.chart3.dispose();
      this.chart3 = null;
    }

    Highcharts.chart('histogramChart', {
      chart: {
        zoomType: 'xy'
      },
      title: {
        // text: 'Hour wise share of annual generation'
        text: ''
      },
      xAxis: [{
        categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
        crosshair: true,
        title: {
          text: 'Hours',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      }],
      yAxis: [{ // Primary yAxis
        labels: {
          format: '{value} %',
          style: this.cstemapi.h_x_y_format
        },
        title: {
          text: 'Generation Share (%)',
          style: this.cstemapi.h_x_y_title_format
        }
      }, { // Secondary yAxis
        title: {
          text: 'Cumulative Generation (MWh)',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          format: '{value}',
          style: this.cstemapi.h_x_y_format
        },
        opposite: true
      }],
      tooltip: {
        shared: true,
        headerFormat: '<b>{point.key}</b><br/>',
        style: this.cstemapi.h_x_y_tooltip_format
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        x: 120,
        verticalAlign: 'top',
        y: 100,
        floating: true,
        backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || 'rgba(255,255,255,0.25)'
      },
      series: [{
        name: 'Cummulative Energy',
        type: 'column',
        yAxis: 1,
        data: Sum,
        tooltip: {
          valueSuffix: ' MWh'
        }
      }, {
        name: 'Energy Share',
        type: 'spline',
        data: SumPC,
        tooltip: {
          valueSuffix: ' %'
        }
      }]
    });
  }

  hourleyChart1(dset, unit) {

    function getData(n) {
      var arr = [],
        i,
        x;
      // console.log(new Date(Date.UTC(new Date().getUTCFullYear(), 0, 1) + 36e5))
      for (
        i = 0, x = Date.UTC(new Date().getUTCFullYear(), 0, 1) - n * 36e5;
        i < n;
        i = i + 1, x = x + 36e5
      ) {
        arr.push([
          x,
          dset[i]
        ]);
      }
      return arr;
    }
    var n = 8760,
      data = getData(n);

    Highcharts.chart('hourlyChart1', {
      chart: {
        zoomType: 'x'
      },
      title: {
        text: ''
      },
      tooltip: {
        valueDecimals: 2,
        formatter: function () {
          return '<b>' + Highcharts.dateFormat('%b %d', this.x) + ' - ' + Highcharts.dateFormat('%H:%M',
            new Date(this.x)) + '</b><br>Hourly Generation: <b>' + this.y + ' ' + unit + '</b>';
        },
        style: this.cstemapi.h_x_y_tooltip_format
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: { // don't display the dummy year
          month: '%b',
          year: '%b'
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        title: {
          text: unit,
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      series: [{
        data: data,
        lineWidth: 0.5,
        name: 'Hourly Generation'
      }]
    });
  }

  hourleyChart2_6(dset, id, unit) {
    // console.log(dset);

    function getData(n) {
      var arr = [],
        i,
        x;
      // console.log(new Date(Date.UTC(new Date().getUTCFullYear(), 0, 1) + 36e5))
      for (
        i = 0, x = Date.UTC(new Date().getUTCFullYear(), 0, 1) - n * 36e5;
        i < n;
        i = i + 1, x = x + 36e5
      ) {
        arr.push([
          x,
          dset[i]
        ]);
      }
      return arr;
    }
    var n = 8760,
      data = getData(n);

    Highcharts.chart(id, {

      chart: {
        zoomType: 'x'
      },
      title: {
        text: ''
      },
      tooltip: {
        valueDecimals: 2,
        formatter: function () {
          return '<b>' + Highcharts.dateFormat('%b %d', this.x) + ' - ' + Highcharts.dateFormat('%H:%M',
            new Date(this.x)) + '</b><br>Hourly Profile: <b>' + this.y + ' ' + unit + '</b>';
        },
        style: this.cstemapi.h_x_y_tooltip_format
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: { // don't display the dummy year
          month: '%b',
          year: '%b'
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        title: {
          text: unit,
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      series: [{
        data: data,
        lineWidth: 0.5,
        name: 'Hourly Profile'
      }]
    });
  }

  degradtionChart(fdata, yAxesName) {
    Highcharts.chart('degradtionChart', {
      title: {
        text: ''
      },
      xAxis: {
        title: {
          text: 'Year',
          style: this.cstemapi.h_x_y_title_format
        },
        tickInterval: 2,
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        title: {
          text: yAxesName,
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
          pointStart: 0
        }
      },
      tooltip: {
        formatter: function () {
          return 'Year ' + this.point.x + ': <b>' + this.point.y + ' ' + yAxesName + '</b>';
        },
        style: this.cstemapi.h_x_y_tooltip_format,
      },
      series: [{
        showInLegend: false,
        name: yAxesName,
        data: fdata
      }],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }

    });
  }

  degradtionChart_battery(hdata) {
    Highcharts.chart('degradtionChart', {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      xAxis: {
        title: {
          text: 'Year',
          style: this.cstemapi.h_x_y_title_format
        },
        tickInterval: 2,
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        title: {
          text: '',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          enabled: false,
          style: this.cstemapi.h_x_y_format
        }
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
          pointStart: 0
        }
      },
      tooltip: {
        formatter: function () {
          return '<b>' + this.point.x + ' year</b>';
        },
        style: this.cstemapi.h_x_y_tooltip_format
      },
      series: [{
        showInLegend: false,
        name: 'Battery Replacement Year',
        data: hdata
      }],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }

    });
  }

  dailyChart() {

    Highcharts.chart('container', {

      data: {
        csv: document.getElementById('csv').innerHTML
      },

      chart: {
        type: 'heatmap',
        margin: [60, 10, 80, 50]
      },

      boost: {
        useGPUTranslations: true
      },

      title: {
        text: 'Highcharts heat map',
        align: 'left',
        x: 40
      },

      subtitle: {
        text: 'Temperature variation by day and hour through 2017',
        align: 'left',
        x: 40
      },

      xAxis: {
        type: 'datetime',
        min: Date.UTC(2017, 0, 1),
        max: Date.UTC(2017, 11, 31, 23, 59, 59),
        labels: {
          align: 'left',
          x: 5,
          y: 14,
          format: '{value:%B}' // long month
        },
        showLastLabel: false,
        tickLength: 16
      },

      yAxis: {
        title: {
          text: null
        },
        labels: {
          format: '{value}:00'
        },
        minPadding: 0,
        maxPadding: 0,
        startOnTick: false,
        endOnTick: false,
        tickPositions: [0, 6, 12, 18, 24],
        tickWidth: 1,
        min: 0,
        max: 23,
        reversed: true
      },

      colorAxis: {
        stops: [
          [0, '#3060cf'],
          [0.5, '#fffbbc'],
          [0.9, '#c4463a'],
          [1, '#c4463a']
        ],
        min: -15,
        max: 25,
        startOnTick: false,
        endOnTick: false,
        labels: {
          format: '{value}℃'
        }
      },

      series: [{
        boostThreshold: 100,
        borderWidth: 0,
        nullColor: '#EFEFEF',
        colsize: 24 * 36e5, // one day
        tooltip: {
          headerFormat: 'Temperature<br/>',
          pointFormat: '{point.x:%e %b, %Y} {point.y}:00: <b>{point.value} ℃</b>'
        },
        turboThreshold: Number.MAX_VALUE // #3404, remove after 4.0.5 release
      }]

    });

  }

  scrollToView(id) {
    var elmnt = document.getElementById(id);
    elmnt.scrollIntoView({
      behavior: 'smooth'
    });
  }

  getBatteryReport(type) {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: type
    };
    var api = 'reports/getBatteryReport'
    this.cstemapi.cstemAPI(dObj).GetBatteryReport.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {

        if (type == 'batteryLoad') {
          var sampleArr = [];
          for (var i = 0; i < 365; i++) {
            sampleArr = sampleArr.concat(resData.values)
          }
          if (sampleArr.length == 8760) {
            setTimeout(() => {
              this.hourleyChart2_6(sampleArr, 'hourlyChart2', 'kW')
            });
          }
        }
        if (type == 'powerToOrFromBattery') {
          setTimeout(() => {
            this.hourleyChart2_6(resData.values, 'hourlyChart3', 'kW')
          });
        }
        if (type == 'excessSupply') {
          setTimeout(() => {
            this.hourleyChart2_6(resData.values, 'hourlyChart4', 'kW')
          });
        }
        if (type == 'unmetLoad') {
          setTimeout(() => {
            this.hourleyChart2_6(resData.values, 'hourlyChart5', 'kW')
          });
        }
        if (type == 'batterySOCProfile') {
          // console.log(resData.values)
          var test = [];
          for (var j = 0; j < resData.values.length; j++) {
            test.push(resData.values[j] * 100)
          }
          if (test.length == 8760) {
            setTimeout(() => {
              this.hourleyChart2_6(test, 'hourlyChart6', '%')
            });
          }
        }
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting hourly aggregate PV generation', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  getBatteryWeekReport(mid) {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      month: mid
    };
    var api = 'reports/getBatteryWeekelyReports'
    this.cstemapi.cstemAPI(dObj).GetBatteryWeekReport.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        var load = []
        for (var i = 0; i < 7; i++) {
          for (var j = 0; j < resData.load.length; j++) {
            load.push(resData.load[j])
          }
          if (load.length == 168) {
            var bdata = [
              { name: 'Load', data: load },
              { name: 'PV Generation', data: resData.pvGen },
              { name: 'To / From Battery', data: resData.toFromBattery }
            ]
            this.batteryWeekChart(bdata, resData.startHour)
          }
        }
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting hourly aggregate PV generation', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  batteryWeekChart(data, xstart) {
    Highcharts.chart('hourlyChart7', {
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        title: {
          text: 'Hours',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        title: {
          text: 'kW',
          style: this.cstemapi.h_x_y_title_format
        },
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
          pointStart: xstart
        }
      },
      tooltip: {
        headerFormat: '<b>{point.key}</b><br/>',
        style: this.cstemapi.h_x_y_tooltip_format,
        valueSuffix: ' kW'
      },
      series: data,
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    });
  }
}
